import { render, staticRenderFns } from "./Add_Arrival.vue?vue&type=template&id=28ca83fa&"
import script from "./Add_Arrival.vue?vue&type=script&lang=js&"
export * from "./Add_Arrival.vue?vue&type=script&lang=js&"
import style0 from "./Add_Arrival.vue?vue&type=style&index=0&id=28ca83fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports